import { Search, Filter } from 'lucide-react'

function BankDetailFilters({
  searchTerm,
  onSearchChange,
  onClearFilters,
  totalItems
}) {
  return (
    <div className="card">
      <div className="card-content">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="label">Search</label>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-secondary-400" />
              <input
                type="text"
                placeholder="Search bank details..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="input pl-10"
              />
            </div>
          </div>
          <div className="flex items-end">
            <button
              onClick={onClearFilters}
              className="btn-outline w-full"
            >
              <Filter className="h-4 w-4 mr-2" />
              Clear Filters
            </button>
          </div>
        </div>
        {totalItems !== undefined && (
          <div className="mt-4 text-base text-secondary-600">
            Showing {totalItems} bank detail{totalItems !== 1 ? 's' : ''}
          </div>
        )}
      </div>
    </div>
  )
}

export default BankDetailFilters

